import { Box as MuiBox, TextField as MuiTextField } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Autocomplete } from "app/shared/UI/Autocomplete/Autocomplete";
import { AutocompleteOption } from "app/shared/UI/Autocomplete";
import { GET_STUDIES_URL_BASE } from "app/shared/constants";
import { StudyListingPageStyle } from "./StudyListingPageStyle";
import SidebarSectionHeader from "./SidebarSectionHeader";
import { useFormik } from "formik";
import axios from "axios";
import { useState } from "react";
import { useTheme } from "@mui/material/styles";

const StudySearchSection = ({ studyId, conditions = [], keywords = [] }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  //const [statusUpdate, setStatusUpdate] = useState(null);

  const theme = useTheme();
  const styles = StudyListingPageStyle(theme);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      conditions: conditions,
      keywords: keywords.map((k) => ({
        ...k,
        displayText: k.displayText || k.value || k.name || "",
      })),
    },
    onSubmit: (values) => {
      saveSearchData(values);
    },
  });

  const saveSearchData = async (formData) => {
    if (!studyId) return;
    setLoading(true);
    try {
      const payload = ((contacts) => {
        return {
          conditions: formData.conditions,
          keywords: formData.keywords.map((kw) => {
            if (typeof kw === "string") {
              return kw.trim();
            } else {
              return kw.name || kw.value || kw.displayText || "";
            }
          }),
        };
      })(formData);

      await axios.patch(
        `${GET_STUDIES_URL_BASE}/study-website-content/${studyId}`,
        payload,
        { headers: { "Content-Type": "application/merge-patch+json" } },
      );
    } catch (err) {
      console.error("Failed to save study search preferences", err);
      //setStatusUpdate("Failed to save your changes. Please try again.");
    }
    setLoading(false);
  };

  return (
    <MuiBox sx={styles.sideBarSection}>
      <SidebarSectionHeader
        title={t("StudyWebisteContentForm.studySearch")}
        loading={loading}
      />

      <MuiBox sx={{ mt: 1 }}>
        <MuiTextField
          fullWidth
          label={t("StudyWebisteContentForm.conditions")}
          name="conditions"
          value={formik.values.conditions}
          onChange={formik.handleChange}
          size="small"
          sx={{ mb: 2 }}
          disabled={loading}
        />

        <Autocomplete
          id="study-keywords"
          freeSolo
          multiple
          label={t("StudyWebisteContentForm.keywords")}
          size="small"
          value={formik.values.keywords}
          getOptionLabel={(option) =>
            typeof option === "string"
              ? option
              : option.displayText || option.value || ""
          }
          isOptionEqualToValue={(option, value) => {
            const optLabel =
              typeof option === "string"
                ? option
                : option.displayText || option.value;

            const valLabel =
              typeof value === "string"
                ? value
                : value.displayText || value.value;

            return optLabel === valLabel;
          }}
          onChange={(evt, selectedOptions) => {
            formik.setFieldValue("keywords", selectedOptions);
            formik.submitForm();
          }}
          renderOption={(props, state, { inputValue }) => (
            <AutocompleteOption
              option={props}
              inputValue={inputValue}
              state={state}
            />
          )}
          urlPrefix={`${GET_STUDIES_URL_BASE}/keywords/search`}
          disabled={loading}
        />
      </MuiBox>
    </MuiBox>
  );
};

StudySearchSection.propTypes = {
  studyId: PropTypes.number.isRequired,
  conditions: PropTypes.array,
  keywords: PropTypes.array,
};

export default StudySearchSection;
